import { createFileRoute } from '@tanstack/react-router'

import SelectTrainPage from '@/layouts/themes/antau/pages/select-train'

export const Route = createFileRoute('/_layout/select-train')({
  component: SelectTrainPage,
})
